import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RecycleBinSVG, WidgetDate, WidgetStatus } from '../../../../../components';
import { sortCaret, headerSortingClasses } from '../../../../../helpers';
import statuses from '../../../../../constants/devices/statuses';

export default function AuditColumns () {
    const { t } = useTranslation();
    return [{
        dataField: 'id',
        text: t('device.table.columns.id'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    },
    {
        dataField: 'type.browser',
        text: t('device.table.columns.browser'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    },
    {
        dataField: 'type.vendor',
        text: t('device.table.columns.vendor'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    },
    {
        dataField: 'type.model',
        text: t('device.table.columns.model'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    },
    {
        dataField: 'type.os',
        text: t('device.table.columns.os'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    },
    {
        dataField: 'created_at',
        text: t('device.table.columns.date'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => {
            return (
                <WidgetDate date={new Date(cellContent)} />
            );
        }
    },
    {
        dataField: 'blocked',
        text: t('device.table.columns.status'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetStatus type={statuses[cellContent]?.type} text={`device.table.status.${cellContent}`} />)
    },
    {
        dataField: 'events',
        text: t('device.table.columns.actions'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        formatExtraData: {
            // setDialog,
        },
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row, rowIndex, { setDialog }) => {
            return (
                <Button
                    className='actionButton'
                    onClick={() => {
                    }}
                >
                    <RecycleBinSVG customStroke={'#F95623'}/>
                </Button>

            );
        }
    }];
}
